import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  CacheInterceptor,
  MockInterceptor,
  RequestInterceptor,
  ResponseInterceptor,
  RetryWhenVisibleInterceptor,
} from '@api/interceptors';

/**
 * This array provides all HTTP interceptors used by the Angular application.
 * - CacheInterceptor: Manages caching logic to improve performance.
 * - RequestInterceptor: Enriches outgoing requests (e.g., adding headers).
 * - ResponseInterceptor: Handles error responses and redirects when necessary.
 * - RetryWhenVisibleInterceptor: Sends a read again once the page is visible when it got no response while hidden.
 * - MockInterceptor: Intercepts requests to return mock data if activated.
 *
 * Using `multi: true` allows Angular to apply multiple interceptors in sequence.
 */
export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CacheInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ResponseInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RetryWhenVisibleInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MockInterceptor,
    multi: true,
  },
];
